/**
 * How the next navigation was started, for the page transition.
 *
 * A phone app slides a screen in when you go deeper and back out when you
 * return, but switching tabs (or picking a section from the menu) swaps the
 * screen in place. The router only knows PUSH / POP / REPLACE, so the tab bar
 * and the drawer mark their own taps here and the shell reads the mark once.
 */
let pending: 'switch' | null = null;

/** Call from a tab bar or menu tap, just before it navigates. */
export function markSectionSwitch() {
  pending = 'switch';
}

/** Read and clear the mark. */
export function takeNavIntent(): 'switch' | null {
  const intent = pending;
  pending = null;
  return intent;
}
